module.exports = __webpack_public_path__ + "static/media/step1.533cd448.png";